import Reflux from 'reflux';

export default Reflux.createActions([
  'update',
  'updateError',
  'updateSuccess',
  'loadStats',
  'loadStatsError',
  'loadStatsSuccess'
]);



/** WEBPACK FOOTER **
 ** ./app/actions/projectActions.jsx
 **/